/**
 * formatMoneyForPdf — Formate un montant en euros pour affichage dans un PDF
 * généré par jsPDF (police helvetica / encodage WinAnsi).
 *
 * Pourquoi un util dédié ?
 *   `toLocaleString('fr-FR')` utilise depuis Node/V8 récent le caractère
 *   U+202F (NARROW NO-BREAK SPACE) comme séparateur de milliers. Or ce
 *   caractère n'est pas présent dans l'encodage WinAnsi par défaut de
 *   jsPDF, ce qui produit des glyphes manquants (espaces fantômes ou
 *   carrés) → les montants en € deviennent illisibles dans la fiche
 *   apprenant.
 *
 * Solution : on normalise tous les espaces "exotiques" (U+202F, U+00A0)
 * en espace ASCII classique avant de retourner la chaîne.
 *
 * 17/06/2026 — fix prod feedback (Fiche apprenant PDF).
 */

/** Remplace les espaces narrow/no-break par un espace ASCII safe pour jsPDF. */
export function normalizePdfSpaces(str) {
  if (str == null) return '';
  return String(str).replace(/[\u00A0\u202F\u2009]/g, ' ');
}

/** Formate un nombre en `1 234 €` (compatible jsPDF). */
export function formatMoneyForPdf(v) {
  if (!Number.isFinite(v)) return '—';
  return `${normalizePdfSpaces(Math.round(v).toLocaleString('fr-FR'))} €`;
}

/** Formate un nombre brut (sans €) pour insertion libre. */
export function formatNumberForPdf(v) {
  if (!Number.isFinite(v)) return '—';
  return normalizePdfSpaces(Math.round(v).toLocaleString('fr-FR'));
}
